export enum ENUM__page_generation_layout_images_edit_tab {
  VIEW = 'VIEW',
  CROP = 'CROP',
  //
  MASK = 'MASK',
  //
  SEGMENTS = 'SEGMENTS',
  SEGMENTS_TO_MASK = 'SEGMENTS_TO_MASK',
  //
  LINE__DRAW = 'LINE__DRAW',
  //
  SELECT = 'SELECT',
}
